<nav class="nav-container">
  <a [routerLink]="'/'" class="home-link">
    <img
      class="mascot"
      src="assets/img/ptero-small.png"
      alt="pterodactyl"
      width="85"
    />
    <img
      class="logo"
      src="assets/img/logo.png"
      alt="STEMTaught Logo"
      width="300"
    />
  </a>
  <ng-container *ngIf="isValid; else loggedOut">
    <div class="link-container">
      <app-settings
        [loggedInUser]="loggedInUser"
        [navLinks]="navLinks"
        [profileLinks]="profileLinks"
      ></app-settings>
    </div>
  </ng-container>
  <ng-template #loggedOut>
    <div class="btn-container">
      <div class="login-button-container">
        <button
          type="button"
          mat-raised-button
          color="primary"
          [routerLink]="signUpPath"
        >
          {{ 'Sign Up' | uppercase }}
        </button>
      </div>
      <div class="login-button-container" *ngIf="route !== 'main-login'">
        <button
          type="button"
          mat-raised-button
          color="primary"
          [routerLink]="loginPath"
        >
          {{ 'Login' | uppercase }}
        </button>
      </div>
    </div>
  </ng-template>
</nav>
